import axios from 'src/utils/axios';

export interface UserProfileData {
  user: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  date_of_birth: string | null;
  ssn_last_four: string | null;
  gender: string;
  disability_status: string;
  disability_types: string[];
  ethnicity: string;
  race_ethnicity: string[];
  asian_sub: string[];
  pacific_islander_sub: string[];
  citizenship_status: string;
  // ENG-3602: hidden-QIT-backed mobility / accommodation demographics.
  mobility_disability: string;
  mobility_disability_expected_12mo: string;
  special_accommodation_needed: string;
  updated: string;
}

export type UserProfilePatch = Partial<
  Omit<UserProfileData, 'user' | 'ssn_last_four' | 'updated'>
> & { ssn?: string };

export interface PersonalInfoSummary {
  completed: number;
  total: number;
  ssn_last_four: string | null;
  last_updated: string | null;
}

export async function getUserProfile(userId: number): Promise<UserProfileData> {
  const { data } = await axios.get<UserProfileData>(
    `user_profile/profile/${userId}/`
  );
  return data;
}

export async function patchUserProfile(
  userId: number,
  body: UserProfilePatch
): Promise<UserProfileData> {
  const { data } = await axios.patch<UserProfileData>(
    `user_profile/profile/${userId}/`,
    body
  );
  return data;
}

export async function revealSsn(userId: number): Promise<{ ssn: string }> {
  const { data } = await axios.post<{ ssn: string }>(
    `user_profile/profile/${userId}/reveal_ssn/`
  );
  return data;
}

export async function getPersonalInfoSummary(
  memberId?: number
): Promise<PersonalInfoSummary> {
  const params = memberId !== undefined ? { member_id: memberId } : {};
  const { data } = await axios.get<PersonalInfoSummary>(
    'data-vault/personal-info-summary/',
    { params }
  );
  return data;
}

export async function getComplianceUserProfilesBulk(
  userIds: number[]
): Promise<UserProfileData[]> {
  const { data } = await axios.post<UserProfileData[]>(
    'user_profile/compliance/profiles/bulk/',
    { user_ids: userIds }
  );
  return data;
}
